import request from '@/utils/request';
import DOMAINS from '@/utils/environment.js';
import { getToken } from '@/utils/storage.js';
/*
 * @Author: your name
 * @Date: 2021-04-10 16:13:31
 * @LastEditTime: 2021-04-10 16:18:50
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /模板/src/api/common.js
 */
// 公共api
// 视导通知详情
export function getNoticeInfo(planId) {
  return request({
    url: `/v1/qws/get/${planId}/notice-info`,
    method: 'get'
  });
}

/**
 *    下载表格
 * @param {*} planId
 */
export function downloadTable(planId) {
  return DOMAINS.BASE_API + `/v1/qws/download/${planId}/supervision/teacher-table?token=${getToken()}`;
}

// 专家分配通知
export function getPlanDistributionInfo(planId) {
  return request({
    url: `/v1/qws/get/plan/${planId}/distribution-info`,
    method: 'get'
  });
}

// 获取下载表格链接
export function getTableLink(planId) {
  return request({
    url: `/v1/qws/get/download/supervision-table/${planId}`,
    method: 'get'
  });
}
